// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1tc7F","tab":"ProcedureTabs_tab__1M7FA"};